import { computed, ref } from 'vue';
import { toast } from 'vue-sonner';
import useUserStore from '@/stores/modules/user';
import { gotoLogin } from '@/utils/auth';

export function useJoinCommunity() {
  const userStore = useUserStore();
  const joining = ref(false);
  const isJoined = computed(() => Boolean(userStore.user.isJoined));
  const isLoggedIn = computed(() => Boolean(userStore.user.id));

  async function handleJoin() {
    if (!isLoggedIn.value) {
      toast.info('请先登录后再加入社区', {
        action: { label: '去登录', onClick: () => gotoLogin() },
        duration: 6000,
      });

      return;
    }

    if (isJoined.value || joining.value) {
      return;
    }

    joining.value = true;

    const { isSuccess } = await userStore.joinCommunity();

    joining.value = false;

    if (isSuccess) {
      toast.success('已成功加入社区');
    }
  }

  return {
    isJoined,
    isLoggedIn,
    joining,
    handleJoin,
  };
}
